/**
 * @file SubmitSuccess
 * @author zhaomiaoyuan
 */
import React from 'react';
import {useHistory} from 'react-router-dom';
import Button from 'antd/lib/button';
import successIcon from '../../asset/img/appeal/submit_succeed.png';
import {recordProxy} from '../../util';
import './index.less';

interface Props {
    listUrl: string;
    desc: string;
    style?:any;
}

export default function SubmitSuccess(props: Props) {
    const {style, listUrl, desc} = props;
    const history = useHistory();
    function goHome() {
        recordProxy('url-home', 'click', '前往首页');
        history.push('/home');
    }

    function goList() {
        recordProxy('url-' + listUrl.split('/').slice(-1)[0], 'click', '查看申诉记录');
        history.push(listUrl);
    }
    return (
        <div className="submit-success" style={style}>
            <img width={152} src={successIcon} />
            <p className="title">提交成功!</p>
            <p className="sub-title">
                {desc || '预计2个工作日内完成审核，请耐心等待，审核结果将通过短信通知您'}
            </p>
            <Button
                className="btn"
                onClick={goHome}>返回首页</Button>
            <Button
                className="btn"
                onClick={goList}>查看申诉记录</Button>
        </div>
    );
}
